import { components } from "@certn/legacy-api/generated-schemas/people";

import { AddressField as ADDRESSES } from "./fields/AddressField";
import { AustraliaLicenceField as AUSTRALIA_LICENCE } from "./fields/AustraliaLicenceField";
import { AustraliaRightToWorkField as AUSTRALIA_RIGHT_TO_WORK } from "./fields/AustraliaRightToWorkField";
import { AustralianNpcIdentificationDocumentsField as AUSTRALIAN_NPC_IDENTIFICATION_DOCUMENTS } from "./fields/AustralianNpcIdentificationDocumentsField";
import { BirthplaceField as BIRTH_PLACE } from "./fields/BirthplaceField";
import { ConsentField as CONSENTS_ACKNOWLEDGED } from "./fields/ConsentField";
import { ConvictionField as CONVICTIONS } from "./fields/ConvictionField";
import { CredentialField as CREDENTIALS } from "./fields/CredentialField";
import { DateField as DATE } from "./fields/DateField";
import { EducationField as EDUCATION } from "./fields/EducationField";
import { EmploymentReferenceField as EMPLOYMENT_REFERENCES } from "./fields/EmployerReferenceField";
import { EmploymentHistoryField as EMPLOYMENT } from "./fields/EmploymentHistoryField";
import { IdentificationDocumentsField as IDENTIFICATION_DOCUMENTS } from "./fields/IdentificationDocumentsField";
import { NameField as NAME } from "./fields/NameField";
import { OneIDField as ONE_ID_VERIFICATION } from "./fields/OneIdField";
import { PassportField as PASSPORT } from "./fields/PassportField";
import { PhotoVerificationField as PHOTO_VERIFICATION } from "./fields/PhotoVerificationField";
import { PositionLocationField as POSITION_OR_PROPERTY_LOCATION } from "./fields/PositionLocationField";
import { ProofOfAddressField as PROOF_OF_ADDRESS } from "./fields/ProofOfAddressField";
import { PurposeField as PURPOSE } from "./fields/PurposeField";
import { SexField as SEX } from "./fields/SexField";
import { SocialMediaField as SOCIAL_MEDIA } from "./fields/SocialMediaField";
import { SocialSecurityNumberField as SOCIAL_SECURITY_NUMBER } from "./fields/SocialSecurityNumberField";
import { TextField as TEXT } from "./fields/TextField";
import { FieldType } from "./fields/types";

const fields: Partial<
  Record<components["schemas"]["Section"]["fields"][0]["type"], unknown>
> = {
  NAME,
  ADDRESSES,
  POSITION_OR_PROPERTY_LOCATION,
  DATE,
  PROOF_OF_ADDRESS,
  BIRTH_PLACE,
  CONVICTIONS,
  CREDENTIALS,
  CONSENTS_ACKNOWLEDGED,
  SEX,
  ONE_ID_VERIFICATION,
  SOCIAL_SECURITY_NUMBER,
  SOCIAL_MEDIA,
  EMPLOYMENT_REFERENCES,
  EMPLOYMENT,
  PURPOSE,
  IDENTIFICATION_DOCUMENTS,
  AUSTRALIAN_NPC_IDENTIFICATION_DOCUMENTS,
  AUSTRALIA_LICENCE,
  PHOTO_VERIFICATION,
  EDUCATION,
  TEXT,
  PASSPORT,
  AUSTRALIA_RIGHT_TO_WORK,
};

export function getField<
  T extends components["schemas"]["Section"]["fields"][0],
>(field: T) {
  if (!fields[field.type]) {
    console.error(`Missing implementation for ${field.type} field`);
    return;
  }

  return (fields[field.type] as (field: T) => FieldType<T>)(field);
}
